package com.example.positionahead.domain

import com.example.positionahead.model.*

object CapitalAllocationSimulator {

    fun generateScenarios(amount: Double, summary: PortfolioSummary, goal: FinancialGoal): List<CapitalScenario> {
        val scenarios = mutableListOf<CapitalScenario>()

        // 1. Fixed Allocation (Top Holdings)
        val fixAlloc = summary.positions.take(3).map { 
            it.position.symbol to (amount / 3) 
        }
        scenarios.add(CapitalScenario("Add to core positions", fixAlloc, "Split equally between your largest existing holdings to reinforce your conviction."))

        // 2. Fix Drift
        val targetStock = goal.effectiveStockTarget()
        val driftAlloc = if (summary.stockAllocationPercent < targetStock) {
            summary.positions.filter { it.position.assetClass == AssetClass.STOCK }.take(2).map { 
                it.position.symbol to (amount / 2)
            }
        } else {
            summary.positions.filter { it.position.assetClass == AssetClass.BOND }.take(2).map { 
                it.position.symbol to (amount / 2)
            }
        }
        scenarios.add(CapitalScenario("Fix allocation", driftAlloc, "Targeting your underweight asset classes to stay balanced with your ${goal.riskTolerance} profile."))

        // 3. Explore Ideas
        val exploreAlloc = listOf("VTI" to amount * 0.6, "QQQM" to amount * 0.4) // Placeholder
        scenarios.add(CapitalScenario("Explore new ideas", exploreAlloc, "Deploy capital into high-fit opportunities from your watchlist or discovery list."))

        return scenarios
    }
}
